import { render, staticRenderFns } from "./create-or-find-customer.vue?vue&type=template&id=704c0641&"
import script from "./create-or-find-customer.vue?vue&type=script&lang=js&"
export * from "./create-or-find-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports